import React, { useState } from 'react';
import { constellationData } from '../data/constellationData';
import { getPairing } from '../data/pairingData';
import ConstellationIcon from '../components/icons/ConstellationIcon';
import './MatchPage.css';

const constellationNames = Object.keys(constellationData);

const MatchPage = () => {
  const [constellation1, setConstellation1] = useState('');
  const [constellation2, setConstellation2] = useState('');

  const pairingResult = getPairing(constellation1, constellation2);

  return (
    <>
      <title>星座配对 - 星座探秘</title>
      <meta name="description" content="选择两个星座，探索它们之间的化学反应、配对指数和相处建议。" />
      <div className="match-page">
        <h1>星座配对</h1>
        <p>选择两个星座，探索你们之间的化学反应。</p>
        <div className="selectors">
          <div className="selector-container">
            <select onChange={(e) => setConstellation1(e.target.value)} value={constellation1}>
              <option value="">选择星座</option>
              {constellationNames.map(name => (
                <option key={name} value={name}>{constellationData[name].chineseName}</option>
              ))}
            </select>
            {constellation1 && <ConstellationIcon name={constellation1} width="100" height="100" />}
          </div>
          <div className="plus-sign">+</div>
          <div className="selector-container">
            <select onChange={(e) => setConstellation2(e.target.value)} value={constellation2}>
              <option value="">选择星座</option>
              {constellationNames.map(name => (
                <option key={name} value={name}>{constellationData[name].chineseName}</option>
              ))}
            </select>
            {constellation2 && <ConstellationIcon name={constellation2} width="100" height="100" />}
          </div>
        </div>

        {pairingResult && (
          <div className="result-container">
            <h2>配对指数: {pairingResult.score}</h2>
            <p>{pairingResult.text}</p>
          </div>
        )}
      </div>
    </>
  );
};

export default MatchPage;
